import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import { get, awardPoints } from "../../util";
import NextGameCard from "../modules/NextGameCard";
import ResultGameCard from "../modules/ResultGameCard";
import { motion } from "framer-motion";
import { Grid } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";

const Dashboard = ({ user }) => {
  const navigate = useNavigate();
  const [games, setGames] = useState([]);
  const [results, setResults] = useState([]);
  const [yesterdayPredictions, setYesterdayPredictions] = useState([]);
  const [predictionsEntered, setPredictionsEntered] = useState(false);

  useEffect(() => {
    if (!user) {
      return navigate("/");
    }
    get("/api/todaygames").then((res) => {
      setGames(res.games);
    });
    get("/api/yesterdayresults").then((res) => {
      setResults(res);
    });
    get("/api/getyesterdaypredictions").then((res) =>
      setYesterdayPredictions(res)
    );
    get("/api/gettodaypredictions").then((res) => {
      setPredictionsEntered(res.length > 0);
    });
  }, [user, navigate]);

  let num_correct_predictions = 0;

  let total_points = 0;
  //make list of games for today's games
  let gamesList = null;
  const hasGames = games.length !== 0;
  if (hasGames) {
    gamesList = games.map((game) => (
      <NextGameCard home={game.home} away={game.away} time={game.time} />
    ));
  } else {
    gamesList = <div>No Games Today :(</div>;
  }

  //make list of game results for yesterday's games
  let resultsList = [];
  for (let i = 0; i < results.length; i++) {
    let result = results;
    let home = result[i].home;

    //find the corresponding prediction object from yesterday
    let matchingPrediction = yesterdayPredictions.filter((obj) => {
      return obj.gameId === result[i]._id;
    })[0];

    if (matchingPrediction === undefined) {
      resultsList.push(
        <ResultGameCard
          home={result[i].home}
          away={result[i].away}
          homeScore={result[i].homeScore}
          awayScore={result[i].awayScore}
          predictedWinner={"--"}
          predictedMargin={"--"}
          pointsBreakdown={"0"}
          pointsEarned={0}
        />
      );
    } else {
      const actual_margin = Math.abs(result[i].homeScore - result[i].awayScore);
      const margin_predicted = matchingPrediction.margin;
      const winner_predicted = matchingPrediction.winner;
      const game_winner =
        result[i].awayScore < result[i].homeScore
          ? result[i].home
          : result[i].away;
      const correct_guess = winner_predicted === game_winner;
      const point_reward = awardPoints(
        actual_margin,
        margin_predicted,
        correct_guess
      );

      if (point_reward[0] > 0) {
        num_correct_predictions += 1;
      }
      total_points = total_points + point_reward[0] + point_reward[1];
      resultsList.push(
        <ResultGameCard
          home={result[i].home}
          away={result[i].away}
          homeScore={result[i].homeScore}
          awayScore={result[i].awayScore}
          predictedWinner={winner_predicted}
          predictedMargin={margin_predicted}
          pointsBreakdown={
            point_reward[0].toString() + "+" + point_reward[1].toString()
          }
          pointsEarned={point_reward[0] + point_reward[1]}
        />
      );
    }
  }

  let html_to_display = user ? (
    <>
      <div className="bg">
        <div className="Dashboard-header Dashboard-bg">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{
              hidden: { scale: 0.8, opacity: 0 },
              visible: {
                scale: 1,
                opacity: 1,
                transition: { delay: 0.08, duration: 0.1 },
              },
            }}
          >
            <header className="Dashboard-headerText">Dashboard</header>
          </motion.div>
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{
              hidden: { scale: 0.8, opacity: 0 },
              visible: {
                scale: 1,
                opacity: 1,
                transition: { delay: 0.2, durant: 0.1 },
              },
            }}
          >
            <h3 className="Dashboard-headersubText">
              Welcome, {user.name.split(" ")[0]}.
            </h3>
            <h3 className="Dashboard-headersubText">Check in on the action.</h3>
          </motion.div>
        </div>

        <div className="Dashboard-topContainer flex flex-row items-center">
          <h2>Today's Predictions: </h2>
          {predictionsEntered ? (
            <h2 className="mh1 CompleteGreen">Complete</h2>
          ) : (
            <h2 className="mh1 IncompleteRed">Incomplete</h2>
          )}
          <h2 className="mh1">Your Season Point Total: {user.totalScore}</h2>
          <h2 className="mh1">
            Yesterday's Record: {num_correct_predictions}-
            {results.length - num_correct_predictions}
          </h2>
          <h2 className="mh1">Yesterday's Score: +{user.yesterdayScore}</h2>
        </div>

        <h2 className="sectionheading">Today's Games</h2>
        <div className="NextGameCard-allGamesContainer">{gamesList}</div>

        <h2 className="sectionheading">Yesterday's Results</h2>
        <h2 className=" u-textCenter lastDayPoints CompleteGreen">
          +{user.yesterdayScore}
        </h2>
        <div className="ResultGameCard-allGamesContainer">
          {resultsList.length ? resultsList : <div>No Games Yesterday :(</div>}
        </div>
      </div>
    </>
  ) : (
    <div className="bg">
      <div className="center-screen">
        <Grid color="black" height={50} width={50} />
      </div>
    </div>
  );
  return html_to_display;
};

export default Dashboard;
